import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { landingPageFAQ } from '../data/faqData';
import { landingPageNews } from '../data/newsData';

interface LandingPageProps {
  onLogin: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onLogin }) => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      {/* Header */}
      <header style={{ 
        padding: '20px 40px', 
        display: 'flex', 
        flexWrap: 'wrap', gap: '16px',
        justifyContent: 'space-between', 
        alignItems: 'center',
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ fontSize: '36px' }}>🎯</span>
          <h1 style={{ margin: 0, color: 'white', fontSize: '28px', fontWeight: 'bold' }}>AvatarMe</h1>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
          <Link className="nav-action" to="/install">📲 Установить приложение</Link>
          <button
            onClick={() => navigate('/faq')}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '10px 20px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            FAQ
          </button>
          <button
            onClick={() => navigate('/news')}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '10px 20px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            Новости
          </button>
          <a
            href="https://t.me/FedorRubtsov"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '28px',
              textDecoration: 'none',
              transition: 'all 0.3s',
              display: 'flex',
              alignItems: 'center',
              filter: 'brightness(0) invert(1)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            title="Связаться с основателем в Telegram"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
            </svg>
          </a>
          <button
            onClick={onLogin}
            style={{
              padding: '12px 30px',
              background: 'rgba(255,255,255,0.2)',
              border: '2px solid white',
              borderRadius: '8px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            Войти
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '80px 40px',
        textAlign: 'center',
        color: 'white'
      }}>
        <h2 style={{ 
          fontSize: '56px', 
          fontWeight: 'bold', 
          margin: '0 0 20px 0',
          lineHeight: '1.2'
        }}>
          Управляй своей жизнью<br />в одном месте
        </h2>
        <p style={{ 
          fontSize: '24px', 
          opacity: 0.95,
          margin: '0 0 50px 0',
          maxWidth: '700px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          Финансы, здоровье, семья и цели — всё под контролем
        </p>
        
        <button
          onClick={onLogin}
          style={{
            padding: '18px 50px',
            background: 'white',
            border: 'none',
            borderRadius: '12px',
            color: '#667eea',
            fontSize: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
            transition: 'all 0.3s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.3)';
          }}
        >
          Войти в аккаунт
        </button>
      </div>

      {/* Features */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto 80px', 
        padding: '0 40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '30px'
      }}>
        {[
          { icon: '💰', title: 'Финансы', desc: 'Отслеживай доходы, расходы и достигай финансовых целей' },
          { icon: '🏥', title: 'Здоровье', desc: 'Контролируй вес, активность и общее состояние здоровья' },
          { icon: '👨‍👩‍👧‍👦', title: 'Семья', desc: 'Управляй семейными событиями и важными датами' },
          { icon: '🎯', title: 'Цели', desc: 'Ставь цели и визуализируй их достижение' },
          { icon: '📊', title: 'Аналитика', desc: 'Получай подробную статистику по всем аспектам жизни' },
          { icon: '🔒', title: 'Безопасность', desc: 'Твои данные защищены и доступны только тебе' }
        ].map((feature, idx) => (
          <div
            key={idx}
            style={{
              background: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(10px)',
              padding: '40px 30px',
              borderRadius: '16px',
              textAlign: 'center',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>{feature.icon}</div>
            <h3 style={{ fontSize: '22px', margin: '0 0 10px 0', fontWeight: 'bold' }}>{feature.title}</h3>
            <p style={{ fontSize: '16px', opacity: 0.9, margin: 0, lineHeight: '1.5' }}>{feature.desc}</p>
          </div>
        ))}
      </div>

      {/* FAQ Section */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto 80px', 
        padding: '0 40px'
      }}>
        <h3 style={{ 
          fontSize: '42px', 
          fontWeight: 'bold', 
          margin: '0 0 40px 0', 
          textAlign: 'center',
          color: 'white'
        }}>
          ❓ Часто задаваемые вопросы
        </h3>
        <div style={{ display: 'grid', gap: '20px' }}>
          {landingPageFAQ.map((faq, idx) => (
            <div
              key={idx}
              style={{
                background: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(10px)',
                padding: '25px 30px',
                borderRadius: '12px',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'white'
              }}
            >
              <h4 style={{ fontSize: '20px', margin: '0 0 10px 0', fontWeight: 'bold' }}>
                {faq.q}
              </h4>
              <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.6' }}>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* News Section */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto 80px', 
        padding: '0 40px'
      }}>
        <h3 style={{ 
          fontSize: '42px', 
          fontWeight: 'bold', 
          margin: '0 0 40px 0', 
          textAlign: 'center',
          color: 'white'
        }}>
          📰 Новости и обновления
        </h3>
        <div style={{ display: 'grid', gap: '25px' }}>
          {landingPageNews.map((news, idx) => (
            <div
              key={idx}
              style={{
                background: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(10px)',
                padding: '25px 30px',
                borderRadius: '12px',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'white',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
            >
              <div style={{ fontSize: '14px', opacity: 0.7, marginBottom: '8px' }}>{news.date}</div>
              <h4 style={{ fontSize: '22px', margin: '0 0 10px 0', fontWeight: 'bold' }}>
                {news.title}
              </h4>
              <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.6' }}>
                {news.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)',
        padding: '60px 40px',
        textAlign: 'center',
        color: 'white'
      }}>
        <h3 style={{ fontSize: '36px', margin: '0 0 20px 0', fontWeight: 'bold' }}>
          Личное пространство AvatarMe
        </h3>
        <p style={{ fontSize: '20px', margin: '0 0 30px 0', opacity: 0.9 }}>
          Сервис используется в частном режиме. Доступ для существующих аккаунтов.
        </p>
        <button
          onClick={onLogin}
          style={{
            padding: '16px 45px',
            background: 'white',
            border: 'none',
            borderRadius: '10px',
            color: '#667eea',
            fontSize: '18px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 6px 25px rgba(0,0,0,0.3)',
            transition: 'all 0.3s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          Войти в аккаунт
        </button>
      </div>
    </div>
  );
};


export default LandingPage;
